import {useRouter} from 'next/navigation';

import {ArrowLink} from '@web-catalog/ui-kit/ArrowLink';

import styles from './IntroComponent.module.scss';

type Props = {
  subtitle?: {
    value: string;
  };
  title?: {
    value: string;
  };
  imageUrl?: string;
  showBackButton: boolean;
};

export const IntroComponent = ({
  subtitle,
  title,
  imageUrl,
  showBackButton,
}: Props) => {
  const router = useRouter();

  const subtitleText = subtitle?.value?.trim();
  const titleText = title?.value?.trim();

  return (
    <div className={styles.container} data-testid="intro">
      {showBackButton && (
        <ArrowLink
          className={styles.backButton}
          href="/"
          onClick={(e) => {
            e.preventDefault();
            router.back();
          }}
        >
          Вернуться назад
        </ArrowLink>
      )}
      {subtitleText && (
        <p className={styles.subtitle} data-testid="subtitle">
          {subtitleText}
        </p>
      )}
      {titleText && (
        <h1 className={styles.title} data-testid="title">
          {titleText}
        </h1>
      )}
      {imageUrl && (
        <div
          data-testid="cover"
          className={styles.cover}
          style={{backgroundImage: `url(${imageUrl})`}}
        />
      )}
    </div>
  );
};
